module.exports = __webpack_public_path__ + "img/GH-kyujin-top-027.6eb1e753.webp";